
<div *ngIf="showSearch">
    <dw-button-bar>
        <button class="btn btn-success" (click)="search()"><i class="fa fa-search"></i> Search</button>

        <button class="btn btn-danger" (click)="cancelSearch()" *ngIf="allowCancel && !showManualBookingButton"><i class="fa fa-times"></i> Cancel</button>

        <button class="btn btn-warning" (click)="switchToManualBooking()" *ngIf="showManualBookingButton"><i class="fa fa-switch"></i> Switch to Manual Booking</button>
    </dw-button-bar>
    <div class="search-title-container" *ngIf="searchResults && !showMultipleCreation">
        <div class="search-title pull-left">Search for Pilot Examiners <i class="fa fa-info-circle" title="Default search is 4 weeks, if none available, adjust your date further into future"></i></div>
        <div class="selected-text pull-right">{{selectedText}}</div>
    </div>
<!--     
    <h2 *ngIf="searchResults">Pilot Examiner Results <i class="fa fa-info-circle" title="Default search is 4 weeks, if none available, adjust your date further into future"></i></h2> 

    <div class="search-text pull-right">{{selectedText}}</div> -->
</div>
<div *ngIf="!showSearch">
    <button class="btn btn-success" (click)="setShowSearch()" *ngIf="!isSectionReadOnly()">Edit Checkride Details</button>
</div>
<div class="parent-container">
    <dw-loading [show]="loading" [text]="loadingMessage"></dw-loading>

    <dw-message [(message)]="message"></dw-message>


    <div *ngIf="searchResults?.length>0 && !showMultipleCreation" class="result-container">
        <!-- {{examinerLocationSelection?.totalSelected }} of {{examinerLocationSelection?.totalAllowed }} Selected -->
        <ng-container *ngFor="let searchResult of searchResults, let i = index">
            <app-examiner-booking-search-result [showDateSelection]="showSearch" [index]="i" [searchResult]="searchResult" [testType]="checkRideRequest.CheckRideTestTypeId" [applicantCheckrideVariables]="applicantCheckrideVariables" (examinerLocationSelectionChange)="examinerLocationSelected()"></app-examiner-booking-search-result>
        </ng-container>

          <!-- <ng-container *ngFor="let examinerLocationDetail of examinerLocationDetails">
            Search Result: {{examinerLocationDetail.searchResult}}
             <app-examiner-booking-search-result (select)="selectDetail(examinerLocationDetail)" (confirm)="confirmDetail(examinerLocationDetail)"  [examinerLocationDetail]="examinerLocationDetail" [showDateSelection]="showSearch" [searchResult]="examinerLocationDetail.searchResult" [examinerLocationSelection]="examinerLocationSelection" [testType]="checkRideRequest.CheckRideTestTypeId" [applicantCheckrideVariables]="applicantCheckrideVariables"></app-examiner-booking-search-result>
        
        </ng-container> -->
    </div> 
    <app-examiner-booking-multiple-creation *ngIf="showMultipleCreation"></app-examiner-booking-multiple-creation>
</div>


<!-- Show Search: {{showSearch }}
Results: {{ searchResults?.length }} -->


              
